<template>
  <div class="box-b">
    <div class="tab" v-if="TabStatus">
      <span
        v-for="(item, index) in tabData"
        :key="index"
        :class="tabval === item.num ? 'setectBg' : ''"
        @click="change(item, index)"
        >{{ item.name }}</span
      >
    </div>
    <div :id="chartId" class="allnav"></div>
  </div>
</template>
<script>
import echarts from "@/js/charts.js";
export default {
  props: {
    chartId: {
      type: String,
      default: "",
    },

    // // tabValue
    // tabval: {
    //   type: Number,
    //   default: 7,
    // },

    // Tab状态
    TabStatus: {
      type: Boolean,
      default: true,
    },

    // 柱状图图例
    legendStatus: {
      type: Boolean,
      default: false,
    },

    xAxisType: {
      type: String,
      default: "category",
    },

    yAxisType: {
      type: String,
      default: "value",
    },

    xName: {
      type: String,
      default: "",
    },

    yName: {
      type: String,
      default: "",
    },

    xData: {
      type: Array,
      default: () => {
        return ["2016", "2017", "2018", "2019", "2020", "2021", "2022"];
      },
    },

    option: {
      type: Object,
      default: () => {
        return {};
      },
    },
  },
  data() {
    return {
      tabData: [
        {
          num: 7,
          name: "近七天",
        },
        {
          num: 30,
          name: "月",
        },
        {
          num: 365,
          name: "年",
        },
      ],
      tabval: 7,

      BarChart1: null,
      option1: {
        tooltip: {
          trigger: "item",
          // formatter: "{b}：{c}",
        },
        legend: {
          show: this.legendStatus,
          textStyle: {
            color: "#FFF",
          },
        },
        grid: {
          top: "20%",
          left: "3%",
          right: "4%",
          bottom: "3%",
          containLabel: true,
        },
        xAxis: {
          type: this.xAxisType,
          data: this.xData,
          name: this.xName,
          nameTextStyle: {
            align: "right",
          },
        },
        yAxis: {
          
          name: this.yName,
          nameLocation: "end",
          boundaryGap: [0, "30%"],
          splitLine: {
            show: true,
            lineStyle: {
              color: "rgba(225, 225, 225, 0.1)"
            }
          }
        },
        series: [
          {
            name: "Direct",
            type: "bar",
            //stack: "total",
            emphasis: {
              focus: "series",
            },
            barWidth: "25%",
            data: [320, 302, 301, 334, 390, 330, 320],
          },
        ],
      },
    };
  },
  beforeDestroy() {
    // 清理工作 避免内存泄漏
    // 销毁监听事件
    window.removeEventListener("resize", this.resizeHandler);
    //this.disposeChart();
  },
  created() {},
  mounted() {
    this.creatChart();
    window.addEventListener("resize", this.resizeHandler);
  },
  methods: {
    // 图表Tab选择
    change(item, index) {
      console.log(item, index, "图表上选择的TAB");
      this.tabval = item.num;
      this.$emit("change", item, index);
    },

    // 环形饼图配置
    creatChart() {
      this.BarChart1 = echarts.init(
        document.getElementById(this.chartId),
        null,
        {
          renderer: "svg",
        }
      );
      this.BarChart1.setOption(this.option1);
    },

    resizeHandler() {
      this.BarChart1.resize();
    },

    // 销毁 Echarts 实例
    disposeChart() {
      this.BarChart1.dispose();
    },
  },
};
</script>
<style lang="scss" scoped>
.box-b {
  width: 100%;
  height: calc(100% - 40px);
  position: relative;
  left: 0;
  bottom: 0;

  .tab {
    width: 100%;
    position: absolute;
    top: 10px;
    text-align: center;
    z-index: 1;

    span {
      display: inline-block;
      width: 51px;
      height: 23px;
      border: 1px solid #0bc4e9;
      font-size: 14px;
      line-height: 23px;
      color: #fff;
      cursor: pointer;
      margin: 5px;
      border-radius: 6px;
    }

    .setectBg {
      background: rgba(10, 167, 255, 0.6);
    }
  }
}

</style>